import React from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import type { Liga } from '../../types/liga';

export interface LeagueTableProps {
  ligas: Liga[];
  loading: boolean;
  onDelete: (liga: Liga) => void;
  onManageImages: (liga: Liga) => void;
}

const formatDate = (value?: string | null) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('pt-BR');
};

const LeagueTable: React.FC<LeagueTableProps> = ({
  ligas,
  loading,
  onDelete,
  onManageImages,
}) => {
  const navigate = useNavigate();

  return (
    <TableContainer component={Paper} className="overflow-visible">
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#6c757d' }}>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
              Nome
            </TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
              Username
            </TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
              Criado em
            </TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
              Iugu configurado?
            </TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
              Ações
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={5} align="center">
                Carregando...
              </TableCell>
            </TableRow>
          )}
          {!loading && ligas.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} align="center">
                Nenhuma liga encontrada.
              </TableCell>
            </TableRow>
          )}
          {!loading &&
            ligas.map((liga) => (
              <TableRow key={liga.id}>
                <TableCell>{liga.nome}</TableCell>
                <TableCell>{liga.username}</TableCell>
                <TableCell>{formatDate(liga.criadoEm)}</TableCell>
                <TableCell>
                  {liga.iuguConfig?.id ? 'Sim' : 'Não'}
                </TableCell>
                <TableCell>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => navigate(`/admin/ligas/${liga.id}/edit`)}
                    >
                      Editar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => onManageImages(liga)}
                    >
                      Imagens
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => onDelete(liga)}
                    >
                      Deletar
                    </button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LeagueTable;







